import moment from 'moment';

export const formatDate = date => {
    if (date) {
        return moment(date).format('DD-MM-YYYY');
    }

    return '';
};

export const formatDateTime = date => {
    if (date) {
        // Add Z for timezone if not already in datestring we get from API data
        if (date.indexOf('T') !== -1) {
            date = date[date.length - 1] !== 'Z' ? `${date}Z` : date;
        }
        return moment(date).format('DD-MM-YYYY HH:mm');
    }

    return '';
};

export const formatISODateTimeForBackend = date => {
    if (date) {
        // Add Z for timezone if not already in datestring we get from API data
        if (!moment.isMoment(date) && date.indexOf('T') !== -1) {
            date = date[date.length - 1] !== 'Z' ? `${date}Z` : date;
        }
        return !moment.isMoment(date)
            ? moment(date)
                  .toISOString()
                  .replace('.000Z', 'Z')
            : date.toISOString().replace('.000Z', 'Z');
    }

    return '';
};

export const formatDateTimeYearFirst = date => {
    if (date) {
        // Add Z for timezone if not already in datestring we get from API data
        if (date.indexOf('T') !== -1) {
            date = date[date.length - 1] !== 'Z' ? `${date}Z` : date;
        }

        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    return '';
};
